import { Controller } from "stimulus";
import 'foundation-sites';
import $ from "jquery";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.selectedItems = [];
    this.selectedItemIds = [];
    this.selectedJobs = [];
    this.lastRemoved = null;
    this.jobBox = document.querySelector(".dotted-box");
    this.jobTextComponent = document.querySelector(".job-text-selection");
    this.jobIcon = document.querySelector(".add-job");
    this.jobTextElement = document.getElementById("selected-job-types");

    // Initialize Foundation only if menuTarget exists
    if (this.menuTarget) {
      $(this.menuTarget).foundation();
    }

    document.addEventListener('click', this.handleClickOutside.bind(this));
    window.addEventListener('pageshow', this.handlePageShow.bind(this));
    this.extractAndApplySelection();
    this.updateApplyButtonVisibility();

    // Define trackEvent if it doesn't exist
    if (typeof window.trackEvent !== 'function') {
      window.trackEvent = (eventName, eventData) => {
        console.log(`Analytics event: ${eventName}`, eventData);
      };
    }

    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this));
    window.removeEventListener('pageshow', this.handlePageShow.bind(this));
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleClickOutside(event) {
    const dropdown = this.menuTarget;
    const jobBox = document.querySelector(".recruiters-job-dropdown");

    if (!dropdown.contains(event.target) && !jobBox.contains(event.target)) {
      this.closeDropdown();
    }
  }

  handlePageShow(event) {
    // Events for going back when page is cached
    if (event.persisted) {
      this.syncFiltersWithURL();
    }
  }

  syncFiltersWithURL() {
    this.clearData();
    const urlParams = new URLSearchParams(window.location.search);
    const placementTypes = urlParams.getAll("placement_types[]");

    if (placementTypes.length > 0) {
      this.showSelectedJobs();
    }

    this.updateButtonText(placementTypes.length === 0);
    this.updateApplyButtonVisibility();
  }

   toggleDropdown(event) {
    event.preventDefault(); // stop <button> from submitting or following default toggle
    event.stopPropagation(); // stop Foundation's click handler from also running

    if (this.menuTarget.classList.contains('is-open')) {
      this.closeDropdown();
    } else {
      this.openDropdown();
      const simulatedEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
      this.menuTarget.dispatchEvent(simulatedEvent);
    }
  }

  openDropdown() {
    this.selectedJobs = document.querySelectorAll(".selected-job");
    this.jobBox.classList.add("selected");
    this.jobTextElement.classList.add("opacity");
    this.jobIcon.classList.add("opacity");

    if (this.selectedJobs.length > 0) {
      this.selectedJobs.forEach(function(job) {
        job.classList.add("opacity");
      });
    }
    $(this.menuTarget).foundation('open');
  }

  closeDropdown() {
    this.selectedJob = document.querySelectorAll(".selected-job");
    this.jobTextElement.classList.remove("opacity");
    this.jobIcon.classList.remove("opacity");
    this.jobBox.classList.remove("selected");

    // Ensure selectedJobs is defined and has elements
    if (this.selectedJobs && this.selectedJobs.length > 0) {
      this.selectedJobs.forEach(function(job) {
        job.classList.remove("opacity");
      });
    }

    $(this.menuTarget).foundation('close');
  }

  clearSelections() {
    this.clearData();
    this.showSelectedJobs();
    this.updateButtonText();
  }
  clearData() {
    this.jobTextElement.classList.remove("opacity");
    this.jobIcon.classList.remove("opacity");
    this.selectedItems = [];
    this.selectedItemIds = [];
    this.lastRemoved = false;
    document.querySelectorAll('.job-item').forEach(jobItem => {
      jobItem.classList.remove('selected');
    });
  }

  resetOptions() {
    this.clearData();
    this.updateButtonText(true);

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete("placement_types[]");
    window.location.href = currentUrl.toString();
    this.jobBox.classList.remove("selected");
    $(this.roleTarget).foundation('close');
  }

  clearOptions() {
    this.clearSelections();
    this.jobBox.classList.remove("selected");
    $(this.menuTarget).foundation('close');
    this.updateApplyButtonVisibility();
  }

  showSelectedJobs() {
    const urlParams = new URLSearchParams(window.location.search);
    const placementTypes = urlParams.getAll("placement_types[]");

    if (placementTypes.length === 0) return;

    placementTypes.forEach(placementType => {
      const [id, name] = placementType.split(',');
      this.selectedItemIds.push(id);
      this.selectedItems.push(name);

      const jobItems = document.querySelector(`[data-job-type-id='${id}']`);
      if (jobItems) {
        jobItems.classList.add('selected');
      }
    });

    this.disableJobTypeButtons(this.selectedItems.length >= 3);
  }

  toggleJobSelection(event) {
    const jobType = event.currentTarget.dataset.jobType;
    const jobTypeId = event.currentTarget.dataset.jobTypeId;
    const jobItem = event.currentTarget;
    const selectedIndex = this.selectedItems.indexOf(jobType);

    if (selectedIndex > -1) {
      this.selectedItems.splice(selectedIndex, 1);
      this.selectedItemIds.splice(selectedIndex, 1);
      jobItem.classList.remove('selected');
    } else {
      if (this.selectedItems.length >= 3) return;
      this.selectedItems.push(jobType);
      this.selectedItemIds.push(jobTypeId);
      jobItem.classList.add('selected');
    }

    this.disableJobTypeButtons(this.selectedItems.length >= 3);

    this.updateApplyButtonVisibility();
  }

  disableJobTypeButtons(condition) {
    document.querySelectorAll('[data-job-type]:not(.selected)').forEach(item => {
      item.classList.toggle('disabled', condition);
    });
  }

  updateApplyButtonVisibility() {
    const applyButton = this.element.querySelector('.jobs-apply-button');
    applyButton.classList.toggle('disabled', this.selectedItems.length === 0);
  }

  updateButtonText(isClear = false) {
    const selectedJobCount = isClear ? 0 : this.selectedItems.length;

    if (selectedJobCount === 0) {
      this.jobTextElement.innerHTML = "Any";
      this.jobTextComponent.style.marginLeft = "0.438rem";
      this.jobBox.style.justifyContent = "center";
      this.jobTextComponent.style.width = "auto";
      document.querySelector("button.dotted-box span img").style.display = "inline";
    } else {
      this.lastRemoved = true;
      const selectedJobsToShow = this.selectedItems.slice(0, 3);
      const jobText = selectedJobsToShow.map(job => `<span class="selected-job">${job}</span>`).join(" ");

      this.jobTextElement.classList.remove("opacity");
      this.jobIcon.classList.remove("opacity");
      this.jobTextComponent.style.width = "100%";
      this.jobBox.style.justifyContent = "flex-start";
      this.jobBox.style.padding = "0.2rem 0.23rem";
      this.jobTextComponent.style.display = "flex";
      this.jobTextComponent.style.marginLeft = "0";
      this.jobTextComponent.style.gap = "0.2rem";
      document.querySelector("button.dotted-box span img").style.display = "none";
      this.jobTextElement.innerHTML = jobText;
    }
  }

  applySelection() {
    console.log("applySelection called", {
      selectedItems: this.selectedItems,
      selectedItemIds: this.selectedItemIds,
      lastRemoved: this.lastRemoved
    });

    this.restoreEffects();

    if (!Array.isArray(this.selectedItemIds)) return;

    // Track analytics event
    console.log("Tracking event with filters:", this.selectedItems.join(', '));
    window.trackEvent("Searched Job Types", {
      filters: this.selectedItems.join(', '),
      userId: this.data.get("currentUser") || 'Visitors',
      source: 'Marketplace'
    });

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('page');
    currentUrl.searchParams.delete('placement_types[]');

    // Send both IDs and names together as single parameters
    this.selectedItemIds.forEach((id, index) => {
      const name = this.selectedItems[index];
      currentUrl.searchParams.append('placement_types[]', `${id},${name}`);
    });

    console.log("New URL after changes:", currentUrl.toString());
    window.location.href = currentUrl.toString();
  }

  restoreEffects() {
    if (this.selectedItems.length === 0 && this.lastRemoved === true) {
      this.lastRemoved = false;
      this.updateButtonText();
      this.jobTextElement.classList.remove("opacity");
      this.jobIcon.classList.remove("opacity");
      this.jobBox.classList.remove("selected");
      $(this.menuTarget).foundation('close');
    }else if(this.selectedItems.length === 0) {
      $(this.menuTarget).foundation('open');
    }else {
      this.lastRemoved = false;
      this.updateButtonText();
      this.jobTextElement.classList.remove("opacity");
      this.jobIcon.classList.remove("opacity");
      this.jobBox.classList.remove("selected");
      $(this.menuTarget).foundation('close');
    }
  }

  applySelectionLandingPage(event = null) {
    this.restoreEffects();
    if (event) {
      this.jobTypesRedirection(event);
    }
  }

  jobTypesRedirection(event) {
    if (!event || !event.currentTarget) {
      return;
    }

    const jobType = event.currentTarget.dataset.jobType;
    const jobItem = event.currentTarget;

    if (jobType) {
      const selectedIndex = this.selectedItems.indexOf(jobType);

      if (selectedIndex > -1) {
          this.selectedItems.splice(selectedIndex, 1);
          jobItem.classList.remove('selected');
      } else {
          this.selectedItems.push(jobType);
          jobItem.classList.add('selected');
      }
    }

    if (Array.isArray(this.selectedItems)) {
      const placementTypes = this.selectedItems;
      const queryString = placementTypes.map(type =>
        `placement_types%5B%5D=${encodeURIComponent(type)}`
      ).join('&');

      // Clear page when redirecting
      const url = `/healthcare_top_recruiters?${queryString}`;
      window.location.href = url;
    }
  }

  landingPageJobTypesRedirection(event) {
    this.selectedItems = [];
    const jobType = event.currentTarget.dataset.jobType;
    const jobItem = event.currentTarget;
    const currentUrl = new URL(window.location.href);
    const newUrl = `${currentUrl.origin}/healthcare_top_recruiters`;
    if (jobType === 'Local Contract' || jobType === 'Staff Position') {
      window.location.href = newUrl;
      return;
    }
    if (jobType) {
      const selectedIndex = this.selectedItems.indexOf(jobType);

      if (selectedIndex > -1) {
        this.selectedItems.splice(selectedIndex, 1);
        jobItem.classList.remove('selected');
      } else {
        this.selectedItems.push(jobType);
        jobItem.classList.add('selected');
      }
    }
    if (Array.isArray(this.selectedItems)) {
      const placementTypes = this.selectedItems;
      const queryString = placementTypes
        .map(type => `placement_types%5B%5D=${encodeURIComponent(type)}`)
        .join('&');

      const currentUrl = new URL(window.location.href);
      let basePath = currentUrl.pathname;
      if (basePath.includes('/gr_marketplace')) {
        basePath = basePath.replace('/gr_marketplace', '/healthcare_top_recruiters');
      }
      else {
        basePath = '/healthcare_top_recruiters';
      }
      currentUrl.searchParams.forEach((value, key) => {
        if (key.startsWith("placement_types")) {
          currentUrl.searchParams.delete(key);
        }
      });
      const newUrl = `${currentUrl.origin}${basePath}?${queryString}`;
      window.location.href = newUrl;
    }
  }

  extractAndApplySelection() {
    const urlParams = new URLSearchParams(window.location.search);
    const placementTypes = urlParams.getAll("placement_types[]");

    if (placementTypes.length !== 0) {
      this.showSelectedJobs();
      this.updateButtonText();
    }
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      this.closeDropdown();
    }
  }
}
